export default "__VITE_ASSET__MX72ygMS__"